jQuery(document).ready(function() {
    jQuery('body:not(.user-role-administrator) .equal_height_singlecolumn .layout__region--column_1').children().wrapAll("<div class='row'></div>");
    // if(jQuery('.signpost_image_wrapper .description').length > 0){
    //     setEqualHeight_CommonClasses('.masonary-wrapper div[data-layout-content-preview-placeholder-label] .signpost_image_wrapper .description');
    // }

    if(jQuery('.card--full-width-content-8-grid').length > 0){
        jQuery('.card--full-width-content-8-grid').each(function(){
            jQuery(this).closest('div[data-layout-content-preview-placeholder-label]').addClass('full-width-content-8-grid');
        });
    }
    if(jQuery('.card--full-width-content-12-grid').length > 0){
        jQuery('.card--full-width-content-12-grid').each(function(){
            jQuery(this).closest('div[data-layout-content-preview-placeholder-label]').addClass('full-width-content-12-grid');
        });
    }
    if(jQuery('.configurable-text').length > 0){
        jQuery('.configurable-text').each(function(){
            jQuery(this).closest('div[data-layout-content-preview-placeholder-label]').addClass('full-width-content');
        });
    }

  /*  jQuery('.masonary-wrapper .layout__region--column_1').prepend('<div class="grid-sizer"></div>');
    setTimeout(function(){
        if(window.matchMedia('(min-width:992px)').matches){
            if(jQuery('.masonary-wrapper').length > 0){
                jQuery('.body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1').masonry({
                    itemSelector: 'body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1 div[data-layout-content-preview-placeholder-label]',
                    columnWidth: '.grid-sizer',
                    percentPosition: true
                });

                jQuery('body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1').isotope({
                  itemSelector: 'body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1 div[data-layout-content-preview-placeholder-label]',
                  masonry: {
                      gutter: 22,
                      layoutMode: 'fitRows',
                      columnWidth: '.grid-sizer'
                     },
                });
            }
        }
    }, 500);*/

    jQuery( window ).resize(function() {
        if(window.matchMedia('(min-width:992px)').matches){
            /*if(jQuery('.masonary-wrapper').length > 0){
                jQuery('.body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1').masonry({
                    itemSelector: 'body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1 div[data-layout-content-preview-placeholder-label]',
                    columnWidth: '.grid-sizer',
                    percentPosition: true
                });
                
                jQuery('body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1').isotope({
                    itemSelector: 'body:not(.user-role-administrator) .masonary-wrapper .layout__region--column_1 div[data-layout-content-preview-placeholder-label]',
                    masonry: {
                       gutter: 22,
                       layoutMode: 'fitRows',
                       columnWidth: '.grid-sizer'
                      },
                }); 
            }*/
            // if(jQuery('.signpost_image_wrapper .description').length > 0){
            //     setEqualHeight_CommonClasses('.masonary-wrapper div[data-layout-content-preview-placeholder-label] .signpost_image_wrapper .description');
            // }
        }
    });

    jQuery('.quote .quote_name, .quote .quote_role').wrapAll("<div class='auther-details'> </div>");
    jQuery('.quote .auther-details, .quote picture').wrapAll("<div class='auther-data'> </div>");
}); //Document Ready End
